<template>
  <nav :class="['navbar', mode === 'light' ? 'navbar-light' : '']" class="mb-5">
      <div class="container">
      <!-- Top Row -->
      <div class="navbar-top">
          <!-- Logo -->
          <div class="logoArea">
          <img
              class="logoIcon"
              :src="mode === 'light' ? require('@/assets/img/Lhitam.png') : require('@/assets/img/Lputih.png')"
              alt="Surpriz.ing logo"
          />

          <span class="logoText">SurPriz.ing</span>
          </div>

          <!-- Hamburger icon (visible only on mobile) -->
          <button class="hamburger" @click="isMenuOpen = !isMenuOpen" v-if="isMobile">
          ☰
          </button>
          
          <!-- Desktop Menu -->
          <ul class="menu" v-if="!isMobile">
              <li><router-link to="/" class="menu-item" exact>Home</router-link></li>
              <li><router-link to="/about-us" class="menu-item" exact>About us</router-link></li>
              <li><router-link to="/features" class="menu-item" exact>Features</router-link></li>
              <li><router-link to="/faq-new" class="menu-item" exact>FAQ</router-link></li>
              <li><router-link to="#" class="menu-item" exact>Contact Us</router-link></li>
          </ul>

          <!-- Desktop CTA buttons -->
          <div class="cta" v-if="!isMobile">
            <button class="btn btn-login" @click="openLink('https://app.surpriz.ing/login')" target="_blank">Log In</button>
            <button class="btn btn-join" @click="openLink('https://app.surpriz.ing')" target="_blank">Join Us</button>
          </div>

      </div>

      <!-- Mobile Menu (including CTA) -->
      <ul v-if="isMobile && isMenuOpen" class="menu open">
          <li><router-link to="/" class="menu-item" exact>Home</router-link></li>
          <li><router-link to="/about-us" class="menu-item" exact>About us</router-link></li>
          <li><router-link to="/features" class="menu-item" exact>Features</router-link></li>
          <li><router-link to="/faq-new" class="menu-item" exact>FAQ</router-link></li>
          <li><router-link to="" class="menu-item" exact>Contact Us</router-link></li>

          <li class="cta-dropdown">
            <button class="btn btn-login" @click="openLink('https://app.surpriz.ing/login')" target="_blank">Log In</button>
            <button class="btn btn-join" @click="openLink('https://app.surpriz.ing')" target="_blank">Join Us</button>
          </li>
      </ul>
      </div>
  </nav>
</template>


<script>
export default {
data() {
  return {
    isMenuOpen: false,
    isMobile: window.innerWidth <= 768
  };
},
  props: {
      mode: {
          type: String,
          default: 'default' // or 'light'
      }
  },
  mounted() {
  window.addEventListener('resize', this.handleResize);
  this.handleResize(); 
},


methods: {
  beforeUnmount() {
  window.removeEventListener('resize', this.handleResize);
},
  handleResize() {
    this.isMobile = window.innerWidth <= 768;
  },

openLink(url) {
  window.open(url, '_blank');
}
}
}
</script>


<style scoped>
/* Navbar */
/* .navbar {
position: relative; 
background: #7970EF;
padding: 24px 80px;
z-index: 10;
display: flex;
align-items: center;
justify-content: center;
min-height: 60px; 
} */

.navbar {
  position: fixed; /* 👈 make it fixed at the top */
  top: 0;
  left: 0;
  width: 100%;
  background: #7970EF;
  padding: 10px 80px;
  z-index: 1000; /* ensure it's above other elements */
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60px;
}

/* navbar 2nd version */
.navbar-light {
background: #FFFFFF;
}

.navbar-light .logoText,
.navbar-light .menu-item {
color: black;
}

.navbar-light .menu-item.active::after {
background: black;
}

.navbar-light .btn-login {
background-color: white;
color: black;
}

.navbar-light .btn-join {
background-color: #FFFFFF;
color: #171717;
border: 1px solid black;
}

@media (max-width: 768px) {
.navbar-light .menu {
  background: white;
}

.navbar-light .menu-item {
  color: black;
}
}


body {
padding-top: 0;
}

.container {
width: 100%;
max-width: 1440px;
display: flex;
align-items: center;
justify-content: space-between;
}

/* Top layout row */
.navbar-top {
display: flex;
justify-content: space-between;
align-items: center;
width: 100%;
}

/* Logo */
.logoArea {
display: flex;
align-items: center;
gap: 12px;
}

.logoIcon {
width: 55px;
height: 40px;
object-fit: contain;
vertical-align: middle;
}
.logoText {
font-size: 20px;
font-weight: 600;
color: #FFFFFF;
line-height: 1;
}

/* Menu */
.menu {
display: flex;
align-items: center;
list-style: none;
gap: 48px;
margin: 0;
}

.menu-item {
font-size: 16px;
font-weight: 500;
color: rgba(255,255,255,0.9);
cursor: pointer;
position: relative;
line-height: 1;
}

.menu-item.active {
font-weight: 600;
}
.menu-item.active::after {
content: "";
position: absolute;
height: 2px;
width: 20px;
background: #FFFFFF;
bottom: -6px;
left: 50%;
transform: translateX(-50%);
}

/* CTA buttons with !important styles kept */
.cta {
display: flex !important;
gap: 16px !important;
align-items: center !important;
position: static !important;
background-color: transparent !important;
color: white !important;
border-radius: 20px !important;
font-size: 14px !important;
font-weight: 500 !important;
width: auto !important;
height: auto !important;
margin: 0 !important;
}

/* Log In button (desktop) */
.btn-login {
background-color: #7970EF;
color: white;
border: none;
border-radius: 20px;
padding: 12px 32px;
font-size: 14px;
font-weight: 500;
cursor: pointer;
white-space: nowrap;
}

/* Join Us button (desktop) */
.btn-join {
background-color: transparent;
color: white;
border: 1px solid white;
border-radius: 20px;
padding: 12px 32px;
font-size: 14px;
font-weight: 500;
cursor: pointer;
white-space: nowrap;
}


/* dropdown menu for mobile */
.cta-dropdown {
display: flex;
flex-direction: column;
gap: 8px;
padding: 10px 20px;
}

.cta-dropdown .btn {
width: 100%;
text-align: center;
}

.hamburger {
display: none;
font-size: 28px;
color: white;
background: none;
border: none;
cursor: pointer;
}

/* Responsive adjustments */
@media (max-width: 1024px) {
.navbar {
  padding: 16px 40px;
}
}

@media (max-width: 768px) {
.container {
  flex-direction: column;
  align-items: flex-start;
  padding: 16px 24px;
}

.navbar {
  padding: 12px 24px;
  flex-direction: column;
  align-items: flex-start;
}

.navbar-top {
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.hamburger {
  display: block;
}

.menu {
  display: none;
  flex-direction: column;
  position: absolute;
  margin-top: 10px;
  top: 70px;
  right: 24px;
  background: white;
  padding: 20px;
  border-radius: 8px;
  z-index: 100;
}

.menu.open {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.menu-item {
  color: black;
  margin-bottom: 10px;
  padding: auto;
}

.cta {
  align-items: flex-start !important;
  width: 100% !important;
  display: none !important; /* hide desktop CTA */
}

.btn-login,
.btn-join {
  width: 100% !important;
  text-align: center !important;
  color: black;
}

.cta-dropdown {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.cta-dropdown .btn {
  width: 100%;
  text-align: center;
}
}

</style>
